// extracted by mini-css-extract-plugin
module.exports = {"form__icon":"ReadSettings_form__icon__XTUqT","form":"ReadSettings_form__3TVmI"};